import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.74906 11.0931V2.71562L10.4091 6.37562C10.7016 6.66812 11.1816 6.66812 11.4741 6.37562C11.7666 6.08312 11.7666 5.61063 11.4741 5.31813L6.53156 0.375625C6.23906 0.083125 5.76656 0.083125 5.47406 0.375625L0.524062 5.31063C0.231563 5.60313 0.231563 6.07562 0.524062 6.36812C0.816562 6.66062 1.28906 6.66062 1.58156 6.36812L5.24906 2.71562V11.0931C5.24906 11.5056 5.58656 11.8431 5.99906 11.8431C6.41156 11.8431 6.74906 11.5056 6.74906 11.0931Z",
		fill: "white"
	})
});
export default SvgArrowUp;
